import HomePage from "./pages/HomePage";
import CatalogPage from "./pages/CatalogPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import RegisterPage from "./pages/RegisterPage";
import SignInPage from "./pages/SignInPage";
import StorefrontLayout from "./components/StorefrontLayout";

/** @type {import('../types').StorefrontTenantModule} */
const eds = {
  key: "eds",
  label: "Elite Drive Solutions",
  domains: ["edsdrive.com", "www.edsdrive.com"],
  codePath: "public-web/src/storefronts/eds",
  pages: {
    home: HomePage,
    catalog: CatalogPage,
    productDetail: ProductDetailPage,
    cart: CartPage,
    checkout: CheckoutPage,
    signIn: SignInPage,
    register: RegisterPage,
    layout: StorefrontLayout,
  },
};

export default eds;
